document.addEventListener("DOMContentLoaded", () => {
   const logoutButton = document.querySelector('a[href*="/en/account/logout"]');
if (logoutButton) {
    logoutButton.addEventListener("click", function (event) {
        event.preventDefault(); // Stop immediate logout

        fetch("/cart.js")
            .then(response => response.json())
            .then(data => {
                let customerId = Shopify.customer ? Shopify.customer.id : null;
const cartElement = document.getElementById('cartData');
    if (cartElement) {
         const cartData = JSON.parse(cartElement.getAttribute("data-cart"));
    console.log("Cart Data:", cartData);

    // ✅ Convert to string before saving
    localStorage.setItem("shopify_cart", JSON.stringify(cartData));

    // ✅ Retrieve and parse properly
    let savedCart = localStorage.getItem("shopify_cart");
    console.log("LocalStorage (string):", savedCart);

    let parsedCart = JSON.parse(savedCart);
    console.log("Parsed LocalStorage (object):", parsedCart);

      } else {
        console.error("❌ Cart data not found.");
    }
               
                return fetch("/cart/clear.js", { method: "POST" });
            })
            .then(() => {
                console.log("✅ Cart saved and cleared on logout.");
                window.location.href = "/account/logout"; // Redirect after saving
            })
            .catch(error => {
                console.error("❌ Logout cart save error:", error);
                // window.location.href = "/account/logout"; // Ensure logout even if there's an error
            });
    });
}



  function restoreCart() {
    let customerId = Shopify.customer ? Shopify.customer.id : true;
    console.log("🔄 Checking for saved cart for Customer ID:", customerId);
 // let savedCart = localStorage.getItem("shopify_cart");
 //    console.log("LocalStorage (string):", savedCart);

 //    let parsedCart = JSON.parse(savedCart);
 //    console.log("Parsed LocalStorage (object):", parsedCart);
    if (customerId) {
       let savedCart = localStorage.getItem("shopify_cart");
    // console.log("LocalStorage (string):", savedCart);

    // let parsedCart = JSON.parse(savedCart);
    // console.log("Parsed LocalStorage (object):", parsedCart);
        if (savedCart) {
            let items = JSON.parse(savedCart);
            let restorePromises = items.map(item => {
                return fetch('/cart/add.js', {
                    method: 'POST',
                    headers: { 'Content-Type': 'application/json' },
                    body: JSON.stringify({ id: item.id, quantity: item.quantity })
                });
            });

            Promise.all(restorePromises)
                .then(() => {
                    console.log("✅ Cart restored successfully.");
                    localStorage.removeItem(`shopify_cart_${customerId}`); // Remove saved cart after restoring
                    location.reload(); // Refresh page to show updated cart
                })
                .catch(error => console.error("❌ Cart restore error:", error));
        } else {
            console.log("⚠ No saved cart found.");
        }
    }
}

// Ensure Shopify.customer is available before calling restoreCart
function checkCustomerAndRestore() {
    if (window.Shopify) {
        console.log("✅ User is logged in. Restoring cart...");
        restoreCart();
    } else {
        console.log("⏳ Waiting for Shopify.customer...");
        setTimeout(checkCustomerAndRestore, 500); // Retry after 500ms
    }
}

// Run restore function when user logs in
if (window.location.pathname.includes("/account")) {
    checkCustomerAndRestore();
}

});
